import dynamic from 'next/dynamic';

import type { DrupalBlock, DrupalImage, DrupalVideo } from '@commons/types/drupal';
import type { Theme } from '@commons/types/styles';

import type { Block } from '..';

/**
 * Lazy loading the component to reduce the initial bundle size.
 *
 * This does not work when used in a pagebuilder factory directly, because every items are loaded at once.
 * Doing it in the component itself ensures that the chunks are only loaded when the component is rendered.
 *
 * @see https://nextjs.org/docs/app/building-your-application/optimizing/lazy-loading
 */

const ScrollableHeadline = dynamic(() => import('./ScrollableHeadline'));

/**
 * Type definition for the ScrollableHeadlineBlock component properties.
 */

export type ScrollableHeadlineProps = DrupalBlock<{
  headlines: string[];
  media: DrupalImage | DrupalVideo;
  scrollableText: string;
  theme?: Theme;
}>;

/**
 * ScrollableHeadlineBlock component.
 *
 * Act as a wrapper to ensure the dynamic import is only done when the component is rendered.
 */

const ScrollableHeadlineBlock: Block = (props: ScrollableHeadlineProps) => (
  <ScrollableHeadline {...props} />
);

/**
 * This block uses GSAP ScrollTrigger, so we disable the default animation.
 */

ScrollableHeadlineBlock.supportsAnimation = false;

export default ScrollableHeadlineBlock;
